import { FC } from 'react';
import { ChevronRight } from 'lucide-react';

interface DashboardListItemProps {
  id: string;
  title: string;
  subtitle: string;
  type?: 'hearing' | 'project';
  status?: string;
  typeBadge?: string;
  statusBg?: string;
  isOverdue?: boolean;
  onClick?: () => void;
}

export const DashboardListItem: FC<DashboardListItemProps> = ({
  id,
  title,
  subtitle,
  type,
  status,
  typeBadge,
  statusBg,
  isOverdue = false,
  onClick,
}) => {
  return (
    <li
      key={id}
      className={`relative flex justify-between gap-x-6 py-4 px-6 bg-(--neutral-white-NW1000) hover:bg-(--neutral-white-NW900) hover:shadow-sm transition-all duration-200 ${
        isOverdue ? 'border-l-4 border-(--danger-D600)' : ''
      } ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="flex min-w-0 gap-x-4">
        <div className="flex flex-col gap-3 min-w-0 flex-auto">
          <p className="[font-size:var(--fs-l4)] font-semibold text-gray-900 group-hover:text-gray-700 transition-colors m-0!">
            {title}
          </p>
          <p className="[font-size:var(--fs-l5)] text-gray-500 truncate m-0!">{subtitle}</p>
          <div className="flex gap-2 flex-wrap">
            {type && typeBadge && (
              <span
                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${typeBadge}`}
              >
                {type === 'hearing' ? 'Course Hearing' : 'Project Review'}
              </span>
            )}
            {status && statusBg && (
              <span
                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${statusBg}`}
              >
                {status}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-x-4">
        <div className="flex items-center">
          <div className="p-1 hover:bg-gray-200 rounded-full transition-colors">
            <ChevronRight className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors" />
          </div>
        </div>
      </div>
    </li>
  );
};
